/**
 * /public/sessions answers 404 when no salon stands behind the widget host or
 * the picked location: "Unknown widget host", or "company not found or
 * inactive" for a switched-off or deleted salon (salon-deletion README §1 in
 * the backend repo — the answer is the same, so the page never says which).
 * The widget then shows a plain "no longer available" page instead of the
 * bootstrap error.
 */
export function isSalonUnavailableError(e: unknown): boolean {
  return (e as any)?.response?.status === 404;
}
